<template>
<div class="index" >
    <div v-for="(li, index) in sort" :key="index">
      <swipe :banner="images" v-if="li.LinkType == 3"></swipe>
      <tablist :tab="list" v-if="li.LinkType == 4"></tablist>
      <cardlist :card="card" v-if="li.LinkType == 2"></cardlist>
    </div>

</div>
</template>
<script>
import store from '@/store/index'
import swipe from './swipe'
import tablist from './tablist'
import cardlist from './cardlist'

export default {
    store,
    components:{
      swipe,
      tablist,
      cardlist
    },
    data() {
    return {
      images: [],
      model: window.AndroidForJsInterface?JSON.parse(window.AndroidForJsInterface.getDeviceInfo()).model:'SKR-A0',
      list: [],
      card:[],
      sort:[],
    }
  },
  methods: {
    getdata(){
      this.$http({
        method: 'get',
        url: '/home',
        params: {
          model: this.model
         },
      })
        .then((res) => {
          // alert(JSON.stringify(res))
          if (res['data']['Code'] === 0) {
            let d = res['data']["Data"]
            this.sort = d
            for(let i=0; i<d.length;i++){
              if(d[i]['LinkType']==2){
                this.card = d[i]['LinkDataItems']
              }else if(d[i]['LinkType']==3){
                this.images = d[i]['LinkDataItems']
              }else if(d[i]['LinkType']==4){
                this.list = d[i]['LinkDataItems']
              }
            }
          } else {
            this.$toast(res['data']["Message"])
          }
        })
    }
  },
  watch:{

  },
  mounted (){
    this.getdata()
  }
}
</script>
<style scoped lang="scss">
.index{
    padding: 0.375rem 1rem 0.875rem;
}
a {
  color: #42b983;
}


</style>
<style lang="scss">
.van-swipe__indicator{
    width: 0.375rem;
    height: 0.375rem;
     &:not(:last-child){
          margin-right:0.375rem;
      }
}
.van-card{
    padding: 0;
    padding-right: 1rem;
    border-radius: 0.375rem;
    height:6rem ;
    .van-card__thumb{
        text-align: left;
        width: 6rem;
        height: 6rem;
        display: block;
        margin-right: 1rem;
        overflow: hidden;
        img{
        border-top-left-radius: 0.375rem;
        border-bottom-left-radius: 0.375rem;
        width: 100%;
        min-height: 100%;
        }
    }
  &:not(:first-child){
    margin-top: 0.75rem;
  }
}
</style>





// WEBPACK FOOTER //
// src/components/index.vue